<template>
  <div 
    class="fts-automation-debugpoint"
    :class="{'automation-debugpoint--active': debugValue}"
    @click="toggleDebug">
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
  methods: {
    toggleDebug() {
      this.debugValue = !this.debugValue;
    },
  },
  computed: {
    debugValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('updateValue', val);
        this.$emit('input', val);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fts-automation-debugpoint {
  height: 0.875rem;
  width: 0.875rem;
  border: 1px solid var(--fts-block-danger);
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
  transition: all .3s ease-in-out;
  &.automation-debugpoint--active {
    background-color: rgba(var(--fts-block-danger-rgb), 0.25);
  }
}
</style>